import { render, staticRenderFns } from "./synx.vue?vue&type=template&id=042bd780&scoped=true"
import script from "./synx.vue?vue&type=script&lang=js"
export * from "./synx.vue?vue&type=script&lang=js"
import style0 from "./synx.vue?vue&type=style&index=0&id=042bd780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042bd780",
  null
  
)

export default component.exports